import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Typography, { TypographyProps } from "@mui/material/Typography";
import { ReactNode } from "react";

import PlaceholderImage from "../PlaceholderImage";
import { PlaceholderImageVariant } from "../PlaceholderImage/declarations";

export interface ContentPlaceholderProps {
  className?: string;
  caption?: string;
  imageGap?: number;
  imageVariant: PlaceholderImageVariant;
  captionVariant?: TypographyProps["variant"];
  textVariant?: TypographyProps["variant"];
  text?: ReactNode;
  children?: ReactNode;
  customImage?: ReactNode;
}

const ContentPlaceholder = ({
  className,
  children,
  caption,
  text,
  imageGap = 7,
  imageVariant,
  customImage,
  captionVariant = "h4",
  textVariant = "paragraphTertiary"
}: ContentPlaceholderProps): JSX.Element => (
  <ContentPlaceholderWrapper className={className} width="100%">
    <ImageWrapper>
      {customImage ? (
        customImage
      ) : (
        <PlaceholderImage alt={caption} variant={imageVariant} />
      )}
    </ImageWrapper>
    <Content marginTop={imageGap}>
      {caption && (
        <ContentPlaceholderCaption variant={captionVariant} align="center">
          {caption}
        </ContentPlaceholderCaption>
      )}
      {text && (
        <ContentPlaceholderText
          color="text.primary"
          variant={textVariant}
          align="center"
        >
          {text}
        </ContentPlaceholderText>
      )}
      {children}
    </Content>
  </ContentPlaceholderWrapper>
);
export default ContentPlaceholder;

export const ContentPlaceholderWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  margin: auto;
`;

export const ContentPlaceholderCaption = styled(Typography)`
  color: ${({ theme }): string => theme.palette.text.primary};
  display: block;
  white-space: pre-line;
  word-break: break-word;
`;

const Content = styled(Box)`
  text-align: center;
`;

const ContentPlaceholderText = styled(Typography)`
  display: block;
  margin-top: ${({ theme }) => theme.spacing(2)};
  overflow-wrap: break-word;
  white-space: pre-line;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
